import { filterCarousel } from "./filter_carousel/filter_carousel_multicorporate";
import { filterGrid } from "./sd_filter_grid/sd_filter_grid";
import { loadMore } from "./molecules/sd_load_more/sd_load_more";
import { hotelDirectory } from './hotel_directory';

document.addEventListener('DOMContentLoaded', () => {
  filterCarousel();
  filterGrid();
  loadMore();
  hotelDirectory();
});

// Legacy - Directorio - Proyectos Corpo
